import { canonical } from './binary.js';
export const assetUrl = (path, assetSet) => `/assets/${canonical(path).split('/').map(encodeURIComponent).join('/')}?assetSet=${encodeURIComponent(assetSet)}`;
export function browserKind(path) {
    if (path.endsWith('.mdl')) return 'model';
    if (path.startsWith('materials/')) return path.endsWith('.vmt') ? 'material' : path.endsWith('.vtf') ? 'texture' : null;
    if (path.startsWith('particles/') && path.endsWith('.pcf')) return 'particle';
    return null;
}
export function embeddedEntries(pak) {
    return [...pak.entries].flatMap(([path, entry]) => { const kind = browserKind(path); return kind ? [{ path, kind, size: entry.size }] : []; });
}
